import React, { useRef, useCallback, useEffect } from 'react';

const A11yIcon = () => (
  <svg
    width="28" height="28" viewBox="0 0 24 24"
    fill="none" aria-hidden="true" focusable="false"
  >
    <circle cx="12" cy="4" r="2.4" fill="currentColor" />
    <path d="M12 7.5v7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M12 9.5l-4.5 2.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M12 9.5l4.5 2.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M12 14.5l-3.5 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M12 14.5l3.5 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default function AccessibilityButton({ onClick, isOpen }) {
  const buttonRef = useRef(null);

  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  useEffect(() => {
    const btn = buttonRef.current;
    if (!btn) return;
    function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick();
      }
    }
    btn.addEventListener('keydown', onKeyDown);
    return () => btn.removeEventListener('keydown', onKeyDown);
  }, [handleClick]);

  return (
    <button
      ref={buttonRef}
      className="a11y-button"
      onClick={handleClick}
      aria-label="Accessibility options"
      aria-expanded={isOpen}
      aria-controls="a11y-panel"
      title="Accessibility"
      tabIndex={0}
      type="button"
    >
      <A11yIcon />
    </button>
  );
}
